module.exports = "../../../../platform/assets/pageMainIcon/icon-zhuangtai-3-yellow.svg";